/**
 * Links into Settings › Sites that open something on arrival (task 454): a
 * site's setup panel, or the Add site dialog. Kept apart from the page so
 * the header's site switcher and the Overview can link there without
 * pulling the lazily loaded Settings route into their chunk.
 */

export const SITES_SETTINGS_PATH = "/dashboard/settings/sites";

/** Names the site whose setup panel is open, for as long as it is open. */
export const SITE_SETUP_PARAM = "setup";

/** Opens the Add site dialog once, then is dropped. */
export const ADD_SITE_PARAM = "add";

export function siteSetupHref(siteId: string): string {
  return `${SITES_SETTINGS_PATH}?${new URLSearchParams({ [SITE_SETUP_PARAM]: siteId })}`;
}

export const ADD_SITE_HREF = `${SITES_SETTINGS_PATH}?${ADD_SITE_PARAM}=1`;
